import type { FC, ReactNode } from 'react'

import { ChatComposer } from '@/components/generals/chat/chat-composer'

interface EmailCaptureProps {
    value: string
    onChange: (value: string) => void
    onSubmit: () => void
    disabled?: boolean
    error?: string | null
}

/** The small second input that appears inside a conversation to collect a work email. */
export const EmailCapture: FC<EmailCaptureProps> = ({ value, onChange, onSubmit, disabled, error }): ReactNode => {
    return (
        <div className='flex animate-bubble-in flex-col items-start gap-1.5'>
            <ChatComposer
                size='sm'
                type='email'
                label='Your work email'
                placeholder='you@company.com'
                sendLabel='Send email address'
                value={value}
                onChange={onChange}
                onSubmit={onSubmit}
                disabled={disabled}
                className='w-full max-w-[330px]'
            />

            {error && (
                <p role='alert' className='pl-4 text-xs text-[#ffb3a3]'>
                    {error}
                </p>
            )}
        </div>
    )
}
